import ButtonComponent from "../elements/ButtonComponent";
import { motion } from "framer-motion";
import { childVariants } from "../../animation/RoutesAnimations";
import { useNavigate } from "react-router-dom";
import Lottie from "react-lottie";
import congratulations from "../../../src/jsons/congratulations.json";

const SellerFormStep8 = () => {
  const navigate = useNavigate();
  const defaultOptionsCard = {
    loop: true,
    autoplay: true,
    animationData: congratulations,
    renderer: "svg",
  };
  return (
    <motion.form
      variants={childVariants}
      initial="initial"
      animate="final"
      className="flex flex-1 gap-12 rounded-md shadow-md"
    >
      <div className="flex flex-col gap-6 w-full   h-[550px]">
        <div className="mx-auto">
          {/* <img
            src="/images/Frame.svg"
            alt="congratulation img"
            className="mr-12 "
          /> */}
          <Lottie options={defaultOptionsCard} height={200} width={200} />
        </div>
        <div className="text-HeadLine/32/Bold text-green-600 flex justify-center ">
          تبریک!
        </div>
        <div className="text-center mx-auto w-[251px] h-[128px] flex flex-col">
          {/* <label className="text-BodyText/16/Regular text-gray-800 ">
            شما هم اکنون{" "}
          </label>
          <label className="text-BodyText/16/Bold text-gray-800 ">
            {" "}
            مجاز به ثبت سفارش
          </label>
          <br></br>
          <label className="text-BodyText/16/Regular text-gray-800  ">
            {" "}
            هستید برای اتمام ثبت‌نام بر روی گزینه تایید کلیک نمایید تا ثبت‌ نام
            شما تکمیل شود.{" "}
          </label> */}
          <p className="text-BodyText/16/Regular text-green-600">
            فروشگاه شما فعال شد.
          </p>
          <p className="text-BodyText/16/Regular text-gray-800">
            پس از مشاهده آموزش <br />
            فروش اقساطی خود را آغاز نمایید.
          </p>
        </div>
        <div className={`mt-[20px] mx-auto text-[14px] flex flex-col gap-4 `}>
          <ButtonComponent
            // onClick={handleButtonClick}
            variant="filled"
            hasIcon
            icon={
              <img
                src="/icons/clapperboard-play-outline.svg"
                alt="icon play video"
                className="bg-white"
              />
            }
          >
            مشاهده ویدیو آموزش سامانه
          </ButtonComponent>
          <ButtonComponent
            variant="outlined"
            // onClick={() => setShowModal(true)}
            className="text-Body-OneLine/14/Medium w-[155px] mx-auto"
          >
            تماس با پشتیبانی
          </ButtonComponent>
        </div>
        <div className="flex w-full justify-center lg:justify-end">
          <ButtonComponent
            className="mt-8 w-[120px] h-10"
            variant="outlined"
            disabled
            // onClick={onBack}
            type="button"
          >
            بازگشت
          </ButtonComponent>
          <ButtonComponent
            type="button"
            className="mt-8 w-[120px] h-10 mr-[8px]"
            variant="filled"
            onClick={() => navigate("/")}
          >
            تایید
          </ButtonComponent>
        </div>
      </div>
    </motion.form>
  );
};
export default SellerFormStep8;
